// * Base
import { NgModule } from '@angular/core';

// * Other
import { SERVER_ERRORS_CONFIG_TOKEN, SntServerErrorsModuleConfig } from './config';
import { SntServerErrorsService } from './server-errors.service';

@NgModule({
  providers: [SntServerErrorsService],
})
export class SntServerErrorsModule {
  static forRoot(config: SntServerErrorsModuleConfig = {}) {
    return {
      ngModule: SntServerErrorsModule,
      providers: [
        {
          provide: SERVER_ERRORS_CONFIG_TOKEN,
          useValue: config,
        },
      ],
    };
  }
}
